export default {
  EVENTS ({ events }) {
    return events
  },
  QUICKLINKS ({ quicklinks }) {
    return quicklinks
  },
  DASHBOARDEVENTS ({ dashboardevents }) {
    return dashboardevents
  },
  OWNERSBYEVENTID ({ ownersByEventId }) {
    return ownersByEventId
  }
}
